import SearchBox from 'components/molecules/SearchBox';
import { UserContext } from 'contexts/ConfigContext';
import { pricingSimulatorDataContext } from 'contexts/PricingSimulatorContext';
import { useContext, useMemo, useState } from 'react';
import { PricingSimulatorNotificationMessages } from 'utils/Enums';
import { queryClient } from 'services/reactQueryService';
import { formatDatePreservingTimeValues, getConfig, sendNotification } from 'utils/helperMethods';
import dayjs from 'dayjs';
import { Button, Switch } from 'antd';
import { PlusSquareOutlined } from '@ant-design/icons';
import AnalyticsIndexTable from 'components/template/PricingSimulator/AnalyticsIndexTable';
import AnalyticsChartContainer from 'components/molecules/PricingSimulator/Analytics/AnalyticsChartContainer';
import BaseScenarioSelectionModal from 'components/molecules/PricingSimulator/Modals/BaseScenarioSelectionModal';
import { useCommonApiHandler } from 'hooks/general/useCommonApiHandler';

type getAllProjectsStateType = {
    search_keyword: string;
    limit: number;
    offset: number;
    sort_by: string;
    sorting_order: 'desc' | 'asc';
    user_name: string;
    report_scope: 'all' | 'self';
};
const simulationSubHeader = 'Deep dive into existing scenarios or compare the scenarios here';

const Analytics = () => {
    const { appConfig } = useContext(UserContext);
    const pricingSimulator = getConfig('pricingSimulator', appConfig);
    const limit = pricingSimulator?.indexPageTableLimit;
    const [searchKey, setSearchKey] = useState<string>('');
    const [openScenarioPopup, setOpenScenarioPopup] = useState(false);
    const [tableReportsReactQueryVariables, setTableReportsReactQueryVariables] = useState<getAllProjectsStateType>({
        search_keyword: '',
        limit,
        offset: 0,
        sort_by: 'updated_at',
        sorting_order: 'desc',
        user_name: localStorage.getItem('email') ?? '',
        report_scope: 'all',
    });

    //called when clicked on search icon or enter
    const onSearch = (val: string) => {
        setTableReportsReactQueryVariables({ ...tableReportsReactQueryVariables, offset: 0, search_keyword: val });
    };

    return (
        <>
            <div className="flex justify-between items-center">
                <div>
                    <h5 className={`font-xs m-0 font-normal text-fontGreyAlt `}>{simulationSubHeader} </h5>
                </div>

                <div className="flex items-center gap-2">
                    <SearchBox onSearch={onSearch} search={searchKey} setSearch={setSearchKey} />
                    <div className="flex items-center gap-2">
                        <p className="text-promoColour font-xxs">My Reports</p>
                        <Switch
                            onChange={(val) => {
                                setTableReportsReactQueryVariables({
                                    ...tableReportsReactQueryVariables,
                                    offset: 0,
                                    report_scope: val ? 'self' : 'all',
                                });
                                queryClient.removeQueries({
                                    exact: false,
                                    queryKey: ['ps-index-table-projects'],
                                });
                            }}
                            checked={tableReportsReactQueryVariables.report_scope === 'self'}
                        />
                    </div>
                    <Button
                        style={{ borderRadius: 4 }}
                        onClick={() => {
                            setOpenScenarioPopup(true);
                        }}
                        type="primary"
                        icon={<PlusSquareOutlined />}
                    >
                        Create New Report
                    </Button>
                </div>
            </div>
            <div className="my-2 border-b border-borderGreyAlt"></div>

            <AnalyticsIndexTable
                tableReportsReactQueryVariables={tableReportsReactQueryVariables}
                setTableReportsReactQueryVariables={setTableReportsReactQueryVariables}
            />
            <BaseScenarioSelectionModal
                mode="analytics"
                from="create"
                open={openScenarioPopup}
                onCancel={(e: any) => {
                    setOpenScenarioPopup(false);
                }}
                onSubmitClick={(data: any) => {
                    //  onEditApply(data);
                }}
            />
        </>
    );
};

export default Analytics;
